module.exports = __webpack_public_path__ + "img/take_part_in_match.4f20b5b5.png";